<template>
	<div class="Makeliving">
		<div class="partOne">
			<div class="inner-box">
				<div class="title">
					<div style="display: flex;align-items: center;">
						<p style="margin-right: 20px;">谋生活灵工</p>
						<p style="font-size: 22px;font-weight: lighter;">专注于现代服务业的酒店餐饮临时用工平台</p>
					</div>
					<div class="url">61MSH.COM</div>
				</div>
				<div class="mshcn">
					<div class="dot"></div>
					<div class="txt">61MSH.COM</div>
				</div>
				<div class="mshcnkj">谋生活灵工<span
						style="font-size: 22px;color: #666;font-family: 'frozen', serif;font-weight: normal;"> /
						简单的、短期的工作就用谋生活灵工</span></div>
				<div class="item"><span>➣</span>用零碎时间赚快钱，让工作拥有更多想象，让生活更加美好</div>
				<div class="item"><span>➣</span>企业的顾虑，我们来解决</div>
				<div class="imgBox">
					<img alt="" src="../assets/images/mshlg.png" width="400" height="300">
				</div>
			</div>
		</div>
		<div class="textcenter">
			<div class="tc-phone">
				<div style="margin: 0 15px;"><i class="fa fa-phone" style="font-size: 25px;font-style: normal;"></i>
				</div>
				<span>400-700-9161</span>
			</div>
			<h3>
				灵活就业及企业用工灵活化服务SaaS服务平台
			</h3>
		</div>
		<div class="partTwo">
			<div class="inner-box">
				<div class="Box">
					<div class="leftBox">
						<img src="../assets/images/banner/bg_3.jpg"/>
						<!-- <img src="../assets/images/img/iphone-bg.png" height="566" width="380" /> -->
					</div>
					<div class="rightBox">
						<div class="url">61MSH.COM</div>
						<div class="one">
							<span class="frozen" data-heading="Frozen">谋生活灵工</span>
							<span>/</span>
							<span style="font-size: 22px;color: #666;font-family: 'frozen', serif;">百家知名企业共同选择
								海量用工人员活跃平台</span>
						</div>
						<div class="two"></div>
						<div class="three">
							<div>
								<span>➣</span>基于互联网应用技术，利用线上便捷的操作流程，将企业大量线上、线下需求分解成微型兼职任务进行在线任务发单，让众多零工人士通过平台找寻对应任务并接单。
							</div>
							<div>
								<span>➣</span>同时，将雇佣数据透明化、数据化，给用户精准定位，谋生活通过平台机制让零工利用空闲时间赚更多的钱。
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="partThree">
			<div class="inner-box">
				<div>
					<h4>我们的特色</h4>
				</div>
				<div class="bb">
					<div class="item flex-center-center">
						<div class="img">
							<div class="imgBox flex-center-center">
								<img alt="" src="../assets/images/czjd.png" width="40">
							</div>
							<div class="txt">操作简易，海量信息发布</div>
						</div>
						<div class="itemActive">
							<div class="txt1">操作简易，海量信息发布</div>
							<div class="txt2">「一键发布招工信息」平台操作简单，招工信息一键发布，工人信息智能匹配</div>
						</div>
					</div>
					<div class="item flex-center-center">
						<div class="img">
							<div class="imgBox flex-center-center">
								<img alt="" src="../assets/images/znpp.png" width="40">
							</div>
							<div class="txt">智能匹配，审核把控严格</div>
						</div>
						<div class="itemActive">
							<div class="txt1">智能匹配，审核把控严格</div>
							<div class="txt2">「海量工人精准撮合」海量工人实名注册，身份信息实名认证，大数据精准撮合</div>
						</div>
					</div>
					<div class="item flex-center-center">
						<div class="img">
							<div class="imgBox flex-center-center">
								<img alt="" src="../assets/images/lcjd.png" width="40">
							</div>
							<div class="txt">流程简便，快速匹配需求</div>
						</div>
						<div class="itemActive">
							<div class="txt1">流程简便，快速匹配需求</div>
							<div class="txt2">「简化流程高效招工」无需进行简历筛选、沟通、面试等复杂流程，高效招工</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="partFour">
			<div class="inner-box">
				<div>
					<h4>我们的优势</h4>
				</div>
				<div class="bb">
					<div class="item flex-center-center">
						<div class="imgBox flex-center-center">
							<img alt="" src="../assets/images/rwsh.png" width="40">
						</div>
						<div class="txt">「全程管控，实时监控」</div>
						<div class="txt">全程管控任务审核、任务结算，客服适时监控</div>
					</div>
					<div class="item flex-center-center">
						<div class="imgBox flex-center-center">
							<img alt="" src="../assets/images/ytb.png" width="40">
						</div>
						<div class="txt">「渠道广，速度快」</div>
						<div class="txt">线上线下同步推进，招聘相应速度快</div>
					</div>
					<div class="item flex-center-center">
						<div class="imgBox flex-center-center">
							<img alt="" src="../assets/images/xl.png" width="40">
						</div>
						<div class="txt">「效率高，成本低，对账准」</div>
						<div class="txt">建议效率高、用工成本低、结算对账准</div>
					</div>
				</div>
			</div>
		</div>
		<my-footer></my-footer>
	</div>
</template>

<script>
	export default {
		name: 'Makeliving',
		created() {

		},
		methods: {

		}
	}
</script>

<style scoped>
	@font-face {
		font-family: "frozen";
		src: url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/209981/Ice%20kingdom%20-%20Bold%20-%20Por%20Kustren.woff");
	}

	.Makeliving {
		background-color: rgb(255, 255, 255);
		height: 100%;
		margin-top: 50px;
	}

	.partOne {
		height: 100%;
		height: 480px;
		/* background-color: #f9fafc; */
		position: relative;
		margin: 0 0 2%;
	}

	.partOne .title {
		width: 1220px;
		height: 80px;
		box-shadow: 0 0px 10px 7px #eff2f8;
		margin-left: -10px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 28px;
		padding: 0 20px;
		border-radius: 12px;
		margin-bottom: 10%;
	}

	.url {
		font-family: "frozen", serif;
		font-size: 43px;
		-webkit-text-stroke: 1px #ff8500;
		-webkit-text-fill-color: white;
		color: white;
		opacity: 0.5;
		margin: 10px 20px;
	}

	.partOne .mshcn {
		margin-left: 5%;
		margin-bottom: 15px;
		display: flex;
		align-items: center;
	}

	.partOne .mshcn .dot {
		width: 12px;
		height: 12px;
		background-color: #ff8400;
		border-radius: 50%;
		margin-right: 10px;
	}

	.partOne .mshcn .txt {
		width: 84px;
		height: 20px;
		font-family: "frozen", serif;
		font-size: 18px;
		color: #ff8400;
		font-weight: 700;
	}

	.partOne .mshcnkj {
		margin-left: 5%;
		font-size: 40px;
		color: #0d1d34;
		font-weight: 600;
		position: relative;
		margin-bottom: 50px;
	}

	.partOne .mshcnkj::before {
		content: "";
		width: 104px;
		height: 2px;
		background-color: #e6e6e6;
		position: absolute;
		left: 70px;
		bottom: -15px;
	}

	.partOne .mshcnkj::after {
		content: "";
		width: 70px;
		height: 4px;
		background: #ff8500;
		border-radius: 2px;
		position: absolute;
		left: 0px;
		bottom: -16px;
	}

	.partOne .item {
		margin-left: 5%;
		display: flex;
		align-items: center;
		line-height: 40px;
		font-size: 14px;
		color: #6e748c;
		font-weight: 400;
	}

	.partOne .imgBox {
		position: absolute;
		right: 0;
		top: 50%;
		margin-top: -5%;
		animation: contentFromRight2Left .6s ease-out;
	}

	.textcenter {
		background-color: #ff8400;
		color: #fff;
		text-align: center;
		padding: 20px 0 20px;
		border: 1px solid #eff2f8;
		/* background: url(../views/svg.png) no-repeat center; */
	}

	.textcenter .tc-phone {
		margin: 20px 0;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.textcenter .tc-phone span {
		font-size: 28px;
		/* font-family: "frozen", serif; */
		/* font-family: PingFangSC-Medium, PingFang SC; */
		font-weight: 500;
		/* color: #ffffff; */
		line-height: 40px;
	}

	.textcenter h3 {
		margin: 20px 0;
		font-size: 28px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		/* color: #ffffff; */
		line-height: 45px;
	}

	.partTwo {
		height: 100%;
		/* background-color: #f9fafc; */
		display: flex;
		flex-direction: column;
		position: relative;
		margin-top: 30px;
	}

	.partTwo .inner-box .Box {
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.partTwo .inner-box .leftBox {
		width: 444px;
		/* height: 580px; */
		text-align: center;
		z-index: 999;
		box-shadow: 0px 0px 10px 10px #eff2f8;
		border-radius: 8px;
		margin: 10px 0 3vw;
	}

	.partTwo .inner-box .rightBox {
		/* width: 700px; */
		height: 360px;
	}

	.frozen {
		/* 最初字体样式 */
		font-size: 30px;
		font-weight: 400;
		margin-left: 20px;
		/* 使用自定义字体 */
		/* font-family: "frozen", serif; */
		/* 设置背景图片 */
		/* background: url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/209981/6963bbf342d87b3a2150bd8f59682b89.jpg); */
		/* 设置文字透明且背景按文字区域裁剪 */
		/* color: transparent; */
		color: #252627;
		-webkit-background-clip: text;
		/* 为了子元素定位 */
		position: relative;
	}
	.frozen::before {
		/* 获取自定义属性文字 */
		content: attr(data-heading);
		/* 使其和父元素文字重叠 */
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		/* 使用颜色混合模式 */
		mix-blend-mode: screen;
		/* 文字透明 */
		color: transparent;
		/* 设置文字阴影 */
		text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2), -2px 2px 10px rgba(0, 0, 0, 0.2), -2px -2px 10px rgba(0, 0, 0, 0.2);
		/* 设置渐变背景 */
		background: linear-gradient(45deg, rgba(255, 255, 255, 0) 45%, rgba(255, 255, 255, 0.8) 50%, rgba(255, 255, 255, 0) 55%, rgba(255, 255, 255, 0) 100%);
		background-size: 200%;
		/* 使用背景图动画 */
		animation: glare 1s infinite;
	}
	
	/* 设置背景图动画 */
	@keyframes glare {
		0% {
			background-position: -100%;
		}
	
		100% {
			background-position: 100%;
		}
	}

	.partTwo .inner-box .rightBox .two {
		top: 10px;
		width: 374px;
		height: 1px;
		background-image: linear-gradient(269deg, #ff8500, rgba(255, 133, 0, 0));
		margin-left: 300px;
		margin-bottom: 20px;
		position: relative;
	}

	.partTwo .inner-box .rightBox .two::before {
		width: 9px;
		height: 9px;
		background: #ff8500;
		content: "";
		position: absolute;
		top: -4px;
		right: 0;
	}

	.partTwo .inner-box .rightBox .three {
		width: 672px;
		height: 120px;
		/* font-family: PingFangSC-Light; */
		font-size: 16px;
		color: #252627;
		line-height: 40px;
		font-weight: 200;
		margin: 30px 25px 10px;
	}

	.partThree {
		height: 500px;
		background-color: #f9fafc;
		display: flex;
		align-items: center;
	}

	h4 {
		font-size: 34px;
		/* font-family: PingFangSC-Medium, PingFang SC; */
		font-weight: 500;
		color: #222426;
		line-height: 48px;
		text-align: center;
	}

	.bb {
		display: flex;
		justify-content: space-between;
		margin-top: 50px;
	}

	.bb .imgBox {
		width: 80px;
		height: 80px;
		background: #fff;
		box-shadow: 0 10px 10px 0 #eff2f8;
		border-radius: 40px;
		margin: 0 auto;
	}

	.bb .item {
		width: 360px;
		height: 260px;
		background: #fff;
		box-shadow: 0 10px 10px 0 #eff2f8;
		border-radius: 10px;
		flex-direction: column;
		position: relative;
	}

	.flex-center-center {
		display: flex;
		align-items: center;
	}

	.flex-center-center,
	.jc {
		justify-content: center;
	}

	.bb .item .txt {
		font-size: 16px;
		color: #1c1c1c;
		text-align: center;
		font-weight: 600;
		margin-top: 30px;
	}

	.partThree .item .itemActive {
		width: 360px;
		height: 200px;
		background: #ff8500;
		border-radius: 10px;
		flex-direction: column;
		padding-top: 25%;
		position: absolute;
		transform: rotatey(90deg);
	}

	.partThree .item:hover .img {
		transform: rotatey(90deg);
		transition: .5s;
	}

	.partThree .item:hover .itemActive {
		transform: rotatey(0deg);
		transition: .7s;
	}

	.partThree .txt1 {
		font-size: 16px;
		color: #fff;
		text-align: center;
		font-weight: 600;
	}

	.partThree .item .itemActive .txt2 {
		margin-top: 10px;
	}

	.partThree .txt2 {
		font-size: 14px;
		color: #fff;
		text-align: center;
		line-height: 30px;
		font-weight: 400;
	}

	.partFour {
		height: 420px;
		background-color: #fff;
		position: relative;
		display: flex;
		align-items: center;
		margin-bottom: 50px;
	}
	.partFour .bb .item:hover {
		background:#ff8500;
		box-shadow: 0 0 0 0;
	}
	.partFour .bb .item:hover .txt{
		color: #fff;
		font-family: "frozen", serif;
	}
	.partFour .bb .item:hover .imgBox{
		box-shadow: 0 0 0 0;
	}
</style>



// WEBPACK FOOTER //
// src/page/Makeliving.vue